import { Component } from '@angular/core';
import { AbstractModal } from '../../../../shared/models/abstract-modal';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-datasets-at-location-error-modal',
  templateUrl: './datasets-at-location-error-modal.component.html',
  styleUrls: ['./datasets-at-location-error-modal.component.scss'],
})
export class DatasetsAtLocationErrorModalComponent extends AbstractModal {
  constructor(protected ngbActiveModal: NgbActiveModal) {
    super(ngbActiveModal);
  }
}
